import { render, staticRenderFns } from "./ArticleShared.pug?vue&type=template&id=728231ee&lang=pug&external"
import script from "./ArticleShared.js?vue&type=script&lang=js&external"
export * from "./ArticleShared.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports